import { useContext } from "react";
import { useQuery } from "react-query";

import { AppContext } from "contexts";
import {
  makeSimpleDeleteRequest,
  makeSimpleGetRequest,
  makeSimplePatchRequest,
  makeSimplePostRequest,
} from "lib/axios";
import { ORDERBOOK_URL } from "services/constants";

import { FavoritedListing } from "./types";

const FAVORITED_LISTINGS_URL = `${ORDERBOOK_URL}/favorited-listings/`;

export type UseFavoritedListingsResponse = FavoritedListing[];

export const useFavoritedListings = () => {
  const appContext = useContext(AppContext);
  const isUserAuthenticated = !!appContext.user;
  return useQuery(
    "favorited-listings",
    () =>
      makeSimpleGetRequest<UseFavoritedListingsResponse>(
        FAVORITED_LISTINGS_URL,
      ),
    { enabled: isUserAuthenticated, staleTime: Infinity },
  );
};

export const favoriteListing = async (
  listingId: number,
  receiveNotifications: boolean,
): Promise<FavoritedListing> => {
  return await makeSimplePostRequest<FavoritedListing>(
    FAVORITED_LISTINGS_URL,
    JSON.stringify({
      listing: listingId,
      receive_notifications: receiveNotifications,
    }),
    [201],
  );
};

export const unFavoriteListing = async (
  favoritedListingId: number,
): Promise<void> => {
  return makeSimpleDeleteRequest<void>(
    `${FAVORITED_LISTINGS_URL}${favoritedListingId}`,
    [204],
  );
};

export const updateFavoritedListing = async (
  favoritedListingId: number,
  receiveNotifications: boolean,
): Promise<void> => {
  return makeSimplePatchRequest<void>(
    `${FAVORITED_LISTINGS_URL}${favoritedListingId}`,
    JSON.stringify({
      receive_notifications: receiveNotifications,
      has_presented_notification_enrollment_to_user: true,
    }),
    [200],
  );
};

const exported = {
  useFavoritedListings,
};
export default exported;
